<template>
<div>
    <v-card width="768" class="mx-auto my-3 pt-3">
        <v-card-text>

            <v-text-field v-model="form.id" label="ID"></v-text-field>
            <h4>Backup</h4>
            <pre class="pre">
                {{ masterStore}}
            </pre>
            <h4>Alterar objeto</h4>
            <v-textarea v-model="form.storeString" outlined></v-textarea>
            <div class="d-flex">
                <v-spacer></v-spacer>
                <v-btn color="primary" elevation="0" class="mx-1" @click="importObject()">Carregar</v-btn>
                <v-btn color="success" elevation="0" @click="save()">Salvar</v-btn>
            </div>
        </v-card-text>
    </v-card>
</div>
</template>
<script>
import moment from "moment";
import config from "@/store/config";
import {
  getFirestore,
  doc,
  setDoc,
} from "firebase/firestore";
import { mapState } from "vuex";
import { initializeApp } from "firebase/app";

export default {
    data: () => ({
        form: {
            id: "",
            storeString: "",
            storeObject: ""
        }
    }),
    computed: {
    ...mapState("groupStores", [
      "allStores",
      "masterStore"
    ])
    },
    mounted() {
        this.importObject()
    },
    methods: {
        importObject(){
            this.form.storeString = JSON.stringify(this.masterStore)

        },
        save(){
            const firebase = initializeApp(config);

            const db = getFirestore(firebase);
            const orderRef = doc(db, "stores", this.form.id);

            const Form = JSON.parse(this.form.storeString)
            setDoc(orderRef, Form).then((res) => {
                console.log('res', res)
            })
        }
    }

}
</script>
<style>
    pre{
        
        line-height: 1.25;
    }
</style>